import React from "react";

const About = () => {
  return (
    <>
      <div className="py-32">
        <div className="container mx-auto px-5">
          <div className="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2">
            <div className="my-auto">
              <h3 className="text-6xl font-bold pb-5">How we win:</h3>
              <p>
                At our core, Avio are storytellers. We work with your team to
                map out a strategic frame for the race, creatively package the
                story and messages then efficiently deliver them to targeted
                voters and decision makers. From launch through Election Day,
                our advertising team, digital strategists and general
                consultants provide hands-on, detailed attention to your needs.
                We offer a full-range of campaign services and we do it better
                than anyone in Republican politics. But what is different about
                Avio is our determination to ensure that your campaign is true
                and unique to you.
              </p>
              <div className="my-8">
                <a href="/" className="btn">
                  Meet Our Team
                </a>
              </div>
            </div>
            <div>
              <img
                src="images/body/a1.png"
                className="object-cover"
                alt="img"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
